/**
 * Voice transcription API (P3-S1 Doc 43).
 *
 * Multipart upload — không dùng api.post (JSON-only).
 */
import { ApiError } from "@/api/client";
import { useAuthStore } from "@/stores/auth";

const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8001";

export interface TranscribeResult {
  text: string;
  language: string;
  duration_ms: number | null;
}

export const voiceApi = {
  async transcribe(blob: Blob, language: string = "vi"): Promise<TranscribeResult> {
    const token = useAuthStore.getState().accessToken;

    const fd = new FormData();
    // Whisper detect ext qua filename — webm/opus default cho MediaRecorder
    const ext = blob.type.includes("webm") ? "webm" : blob.type.includes("ogg") ? "ogg" : "webm";
    fd.append("audio", blob, `recording.${ext}`);
    fd.append("language", language);

    const headers: Record<string, string> = { Accept: "application/json" };
    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await fetch(`${BASE_URL}/api/v1/voice/transcribe`, {
      method: "POST",
      body: fd,
      headers,
      credentials: "include",
    });

    if (!response.ok) {
      let detail = `${response.status} ${response.statusText}`;
      try {
        const body = (await response.json()) as { detail?: string; title?: string };
        detail = body.detail ?? body.title ?? detail;
      } catch {
        // ignore
      }
      throw new ApiError(response.status, detail);
    }

    return (await response.json()) as TranscribeResult;
  },
};
